require('components/commons/wizard/wizard.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');
// @ utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
// @ components
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const WizardProgressIndicator = require('components/commons/wizard/wizardProgressIndicator/wizardProgressIndicator');
const WizardHeaderMenu = require('components/commons/wizard/wizardHeaderMenu/wizardHeaderMenu');
// @ helpers
const { formatText } = require('core/i18n').i18n;

class CmWizard extends React.Component {
    constructor(props) {
        super(props);

        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleFinishClick = this.handleFinishClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleGoBackClick = this.handleGoBackClick.bind(this);
        this.buildStep = this.buildStep.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.visibleStep !== prevProps.visibleStep) {
            scrollToTop();
        }
    }

    componentWillUnmount() {
        scrollToTop();
    }

    buildPreLeaveModal() {
        const {
            onPreLeaveModalReady,
            showPreLeaveModal,
            preleaveModalTitle,
            preleaveModalMessage,
            preleaveModalLeftButtonConfig,
            preleaveModalRightButtonConfig,
            onConfirmLeave,
        } = this.props;

        let dataToRender;

        if (showPreLeaveModal) {
            const acceptText = formatText(
                'wizard-redirectConfirmationAcceptButton',
            );
            const cancelText = formatText(
                'wizard-redirectConfirmationCancelButton',
            );
            const confirmationTitle = preleaveModalTitle
                ? preleaveModalTitle
                : formatText('wizard-redirectConfirmationTitle');
            const confirmationMessage = preleaveModalMessage
                ? preleaveModalMessage
                : formatText('wizard-redirectConfirmationMessage');

            dataToRender = (
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={onPreLeaveModalReady}
                    leftButtonConfig={preleaveModalLeftButtonConfig}
                    rightButtonConfig={preleaveModalRightButtonConfig}
                    onConfirmLeave={() => {
                        if (!!onConfirmLeave) {
                            onConfirmLeave();
                        }
                    }}
                />
            );
        }

        return dataToRender;
    }

    buildStep() {
        return React.Children.map(this.props.children, (child, index) => {
            const { visibleStep } = this.props;
            const active = visibleStep === index + 1;

            if (active) {
                const { isFetching } = this.props;
                let additionalProps = {
                    isFetching: !!isFetching,
                    actions: this.createStepActions(),
                };

                if (child.props.addLoadingBehaviour) {
                    additionalProps.isLoading =
                        child.props.isLoading || isFetching;
                }

                return React.cloneElement(child, additionalProps);
            }
        });
    }

    buildWizardHeaderMenu() {
        const { hasHeaderMenu, headerMenuData } = this.props;
        let headerMenu;

        if (hasHeaderMenu) {
            headerMenu = <WizardHeaderMenu headerMenuData={headerMenuData} />;
        }

        return headerMenu;
    }

    createStepActions() {
        return {
            handlePrevClick: this.handlePrevClick,
            handleNextClick: this.handleNextClick,
            handleCancelClick: this.handleCancelClick,
            handleFinishClick: this.handleFinishClick,
            handleGoBackClick: this.handleGoBackClick,
        };
    }

    handleCancelClick() {
        const {
            actions: { cancel, setWillCancel },
        } = this.props;

        setWillCancel(true);

        if (cancel) {
            cancel();
        }
    }

    handleFinishClick() {
        const { actions, visibleStep, immSteps, history } = this.props;

        if (
            immSteps.get(visibleStep - 1).get('hasSignaturePattern') &&
            !immSteps.get(visibleStep - 1).has('valid')
        ) {
            //if has signaturePattern and no extra validation, then skip validation
            actions.finish();
        } else {
            actions.validateStep(visibleStep, history);

            if (immSteps.get(visibleStep - 1).get('valid')) {
                actions.finish();
            }
        }
    }

    handleGoBackClick() {
        this.props.actions.setWillGoBack(true);
    }

    handleNextClick() {
        const { actions, visibleStep, history } = this.props;
        actions.validateStep(visibleStep, history);
    }

    handlePrevClick() {
        const { actions, visibleStep } = this.props;

        actions.setVisibleStep(visibleStep - 1);
        if (actions.resetStep) {
            //reset leaving step
            actions.resetStep(visibleStep);
        }
    }

    render() {
        const {
            wizardClass,
            visibleStep,
            stepsAmount,
            immSteps,
            fullWidth,
        } = this.props;
        const step = this.buildStep();
        const preLeaveModal = this.buildPreLeaveModal();
        const wizardClassName = classnames('wizard', wizardClass);
        let stepContent;
        const wizardHeaderMenuBlock = this.buildWizardHeaderMenu();

        if (fullWidth) {
            stepContent = (
                <section className="col-xs-offset-2 col-xs-8">{step}</section>
            );
        } else {
            stepContent = step;
        }

        const wizardStepsClassName = classnames('wizard__steps', {
            'row no-gutter clearfix wizard__steps--full-width': fullWidth,
        });

        return (
            <article className={wizardClassName}>
                <section className="wizard__header">
                    {wizardHeaderMenuBlock}
                    <WizardProgressIndicator
                        visibleStep={visibleStep}
                        stepsAmount={stepsAmount}
                        immSteps={immSteps}
                    />
                </section>
                <section className={wizardStepsClassName}>
                    {stepContent}
                </section>
                {preLeaveModal}
            </article>
        );
    }
}

CmWizard.propTypes = {
    history: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    children: PropTypes.any,
    immSteps: PropTypes.object.isRequired,
    visibleStep: PropTypes.number.isRequired,
    wizardClass: PropTypes.string,
    stepsAmount: PropTypes.number,
    isFetching: PropTypes.bool,
    fullWidth: PropTypes.bool,
    setWizardSuccess: PropTypes.func,
    setWizardError: PropTypes.func,
    setWizardLoading: PropTypes.func,
    resetWizard: PropTypes.func,
    hasHeaderMenu: PropTypes.bool,
    headerMenuData: PropTypes.object,
    onConfirmLeave: PropTypes.func,
    processType: PropTypes.string,

    //preleave modal related propTypes.

    preleaveModalLeftButtonConfig: PropTypes.shape({
        text: PropTypes.string,
        callback: PropTypes.func,
        redirect: PropTypes.bool,
    }),
    preleaveModalRightButtonConfig: PropTypes.shape({
        text: PropTypes.string,
        callback: PropTypes.func,
        redirect: PropTypes.bool,
    }),
    onPreLeaveModalReady: PropTypes.func,
    preleaveModalMessage: PropTypes.string,
    preleaveModalTitle: PropTypes.string,
    showPreLeaveModal: PropTypes.bool,
};

CmWizard.defaultProps = {
    fullWidth: false,
    hasHeaderMenu: false,
    onPreLeaveModalReady: () => {
        return false;
    },
    showPreLeaveModal: false,
};

module.exports = withRouter(CmWizard);
